import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Menu } from '@material-ui/core';
import { DeleteOutlineRounded, MoreVertRounded } from '@material-ui/icons';
import { groupActions } from '../../../redux/actions';
import Text from '../../../shared/common/Text';
import { MenuItemStyle } from '../styled-components/groups.styled.components';

const TableMenu = props => {
    const { id } = props;
    // REDUX
    const dispatch = useDispatch();

    const ondemand_id = useSelector(state => state.user.user.id);

    // STATE
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    // FUNCTIONS
    function handleOpen(e) {
        setAnchorEl(e.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function removeUser() {
        dispatch(groupActions.removeGroupRequest({ id, ondemand_id }));
        handleClose();
    }

    // RETURN
    return (
        <>
            <IconButton size="small" aria-controls="menu-appbar" onClick={handleOpen}>
                <MoreVertRounded fontSize="small" />
            </IconButton>
            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                onClose={handleClose}>
                <MenuItemStyle onClick={removeUser}>
                    <DeleteOutlineRounded color="error" fontSize="small" />
                    <Text fontSize="0.75rem" fontWeight="400" color="error">
                        Eliminar
                    </Text>
                </MenuItemStyle>
            </Menu>
        </>
    );
};

export default TableMenu;
